export enum ServiceStatus {
  waitlist = 'waitlist',
  service = 'service',
  completed = 'completed',
  pending = 'pending'
}
